import React from 'react';
import { Spinner, TruncatedText, AddButton } from '@td-client-frontend/common';
import WithPermission, { PermMode } from './WithPermission';

interface NoResultsDialogProps {
  headers: string[];
  noResultAction: () => void;
  noResultsLabel: string;
  newEntryLabel: string;
  permissionsForButton: string[];
}

interface ListProps {
  title: string;
  headers: string[];
  loading: boolean;
  children: React.ReactNode;
}

export function Th({ children }: { children: React.ReactNode }) {
  return (
    <th
      data-testid="table-head"
      scope="col"
      className="sticky top-0 px-4 py-5 text-sm font-normal text-left uppercase whitespace-no-wrap bg-white border-b-2 border-gray-15 "
    >
      {children}
    </th>
  );
}

export function Td({ children }) {
  const childrenToRender = typeof children === 'string' ? <TruncatedText label={children} /> : children;

  return <td className="px-4 py-5 text-sm font-effra text-black-default">{childrenToRender}</td>;
}

export function NoResultsDialog({
  headers,
  noResultAction,
  noResultsLabel,
  newEntryLabel,
  permissionsForButton = ['']
}: NoResultsDialogProps) {
  return (
    <>
      <tr>
        <td colSpan={headers.length || 1} className="py-4 font-effra">
          <span className="my-4">{noResultsLabel}</span>
        </td>
      </tr>
      {noResultAction && (
        <WithPermission requiredPerms={permissionsForButton} mode={PermMode.ANY}>
          <tr>
            <td colSpan={headers.length || 1} className="text-center">
              <AddButton label={newEntryLabel} onClick={noResultAction} />
            </td>
          </tr>
        </WithPermission>
      )}
    </>
  );
}

export function List({ title, headers, loading, children }: ListProps) {
  return (
    <div className="relative w-full h-full overflow-auto">
      <div className="absolute w-full h-full">
        <table className="w-full table-fixed">
          <caption className="visually-hidden">{title}</caption>
          <thead className="border-b-2">
            <tr>
              {headers?.map((header: string) => (
                <Th key={header}>{header}</Th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={headers.length || 1} className="w-full py-8 text-center font-effra">
                  <div className="flex items-center justify-center">
                    <Spinner />
                  </div>
                </td>
              </tr>
            )}
            {children}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default List;
